"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slateUtilWhat = require("@canner/slate-util-what");

var _slateUtilGet = require("@canner/slate-util-get");

var _default = function _default(change, options) {
  var type = options.type; // if type exist, remove same type mark

  if ((0, _slateUtilWhat.whatMarkTypes)(change).has(type)) {
    (0, _slateUtilGet.getMarkType)(change, type).forEach(function (mark) {
      change.removeMark(mark);
    });
  }

  return change.addMark(options).focus();
};

exports.default = _default;